import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'
import { minimalAdminUserPermissions } from './AdminPermissions'

export enum PlatformPermissionSet {
  UsePortal = 'launch_use_portal',
  ViewSensitiveInformation = 'view_sensitive_information',
}

// Ignore prettier to ensure only one permission per line
// prettier-ignore
export const platformPermissionSetGrouping: IPermissionSetGrouping<PlatformPermissionSet> = {
  key: PermissionSetGroupingKey.Platform,
  active: {
    [PlatformPermissionSet.UsePortal]: [
      ...minimalAdminUserPermissions,
      PermissionType.CAN_USE_ADMIN_PORTAL, // Required for Spare Launch to appear
      PermissionType.GET_OWN_BILLING_ACCOUNT_ALERT_STATUS, // Show banner if Spare invoice is overdue
    ],
    [PlatformPermissionSet.ViewSensitiveInformation]: [
      PermissionType.GET_SENSITIVE_INFORMATION,
    ],
  },
  unAssignablePermissionSets: [],
}
